import clsx from "clsx";

export function Spinner({
  className,
  size = 6,
}: {
  className?: string;
  size?: number;
}) {
  return (
    <div
      role="status"
      aria-label="Loading"
      className={clsx(
        "inline-block animate-spin rounded-full border-2 border-current border-t-transparent text-brand-600",
        className
      )}
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
    />
  );
}
